<script>

	import {onMount}from 'svelte';
	import Question from './Question.svelte'
	import Result from './Result.svelte';

	let basePath = '';
	let nextLink = basePath + '/api/';
	let question;
	let actualQuestionNo;
	let result;
	let quizzRunning = false;

	onMount: {
		runIt();
	}

	async function runIt () {

		const res = await fetch(nextLink, {
			method: 'GET'
		});

		const json = await res.json()
		if (json['_links']['next']) {
			nextLink = basePath + json['_links']['next']['href'];
		}

		if (json['_embedded']) {
			if (json['_embedded'].question) {
				question = json['_embedded'].question;
				actualQuestionNo = json.actualQuestionNo;
				allQuestionCount = json.allQuestionCount;
			} else if (json['_embedded'].result) {
				result = json['_embedded'].result;
			}
		} else {
			question = undefined
		}

	}

	async function answerQuestion(event) {

		quizzRunning = true;

		let selectedAnswer = event.detail.selectedAnswer;

		const res = await fetch(nextLink, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				ID: selectedAnswer
			})
		});

		const json = await res.json();

		if (json['_links']['next']) {
			nextLink = basePath + json['_links']['next']['href'];
		}

		if (json['_embedded']) {
			if (json['_embedded'].question) {
				question = json['_embedded'].question;
				actualQuestionNo = json.actualQuestionNo;
				allQuestionCount = json.allQuestionCount;
			} else if (json['_embedded'].result) {
				result = json['_embedded'].result;
			}
		} else {
			question = undefined;
			runIt()
		}

	}

</script>

{#if question}
	<Question {question} {actualQuestionNo} on:answered={answerQuestion}/>
{:else if result}
	<Result {result}/>
{:else if !quizzRunning}

	<h1>Gwizz - das Golang Quizz</h1>
	<p>
		Teste Dein Golang Wissen!
	</p>
	<button type="button" on:click={runIt}>
		Start
	</button>

{/if}
